import type { ReactNode } from 'react'
import { Nav, Tab, Row, Col } from 'react-bootstrap'
import map from 'lodash/map'

export type SideNavigationProps = { navigationLinks: string[]; children: ReactNode }
export const SideNavigation = ({ navigationLinks, children }: SideNavigationProps) => {
  return (
    <Row>
      {/* The column takes its content height; a page that needs it taller sets `--side-navigation-min-height`
      above this (`RouteOffCanvas` sets `--offcanvas-width` the same way). */}
      <Col md={2} className="shadow-sm border-end" style={{ minHeight: 'var(--side-navigation-min-height, 0)' }}>
        {/* The active pill's label colour is each app's own compiled `$nav-pills-link-active-color`, a
        compile-time token identical in both colour modes. A runtime foreground picker is wrong here —
        that's for a fill only known at runtime, not a value fixed at build time. */}
        <Nav variant="pills" className="flex-column">
          {map(navigationLinks, (link) => (
            <Nav.Link key={link} eventKey={link}>
              {link}
            </Nav.Link>
          ))}
        </Nav>
      </Col>
      <Col md={10}>
        <Tab.Content>{children}</Tab.Content>
      </Col>
    </Row>
  )
}
